webpackJsonp([6],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unmountNotePanel = exports.renderNotePanel = undefined;
	
	__webpack_require__(120);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _NotePanel = __webpack_require__(678);
	
	var _NotePanel2 = _interopRequireDefault(_NotePanel);
	
	var _Messages = __webpack_require__(119);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _MessageDefinitions = __webpack_require__(245);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _Locale = __webpack_require__(118);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function render(nodeId) {
	  var mountNode = document.getElementById(nodeId);
	  var messages = _Messages2.default.get(_MessageDefinitions2.default);
	
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactIntl.IntlProvider,
	    { locale: (0, _Locale.getLocale)(), messages: messages },
	    _react2.default.createElement(_NotePanel2.default, null)
	  ), mountNode);
	}
	
	function renderNotePanel(notePanelId) {
	  render(notePanelId);
	}
	
	function unmountNotePanel(notePanelId) {
	  _reactDom2.default.unmountComponentAtNode(document.getElementById(notePanelId));
	}
	
	if (window.ignite) {
	  window.ignite.renderNotePanel = renderNotePanel;
	
	  window.ignite.unmountNotePanel = unmountNotePanel;
	}
	
	exports.renderNotePanel = renderNotePanel;
	exports.unmountNotePanel = unmountNotePanel;

/***/ },

/***/ 245:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * (c) 2015 Ignite Sales, Inc.
	 * User: aholmes
	 * Date: 6/8/2016
	 * Time: 9:58 AM
	 */
	exports.default = {
	  addNote: {
	    id: 'note.addNote',
	    description: 'Message for adding a note',
	    defaultMessage: 'New Note'
	  },
	  newNoteTitle: {
	    id: 'note.newNote.title',
	    description: 'Title for adding a note',
	    defaultMessage: 'Enter a note:'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 677:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditNote = exports.ViewNote = undefined;
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MessageDefinitions = __webpack_require__(245);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewNote = function ViewNote(_ref) {
	  var note = _ref.note,
	      onEdit = _ref.onEdit,
	      onRemove = _ref.onRemove;
	  var content = note.content,
	      timestamp = note.timestamp,
	      _note$employee = note.employee,
	      firstName = _note$employee.firstName,
	      lastName = _note$employee.lastName;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'card note' },
	    _react2.default.createElement(
	      'div',
	      { className: 'card-block' },
	      content
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'card-footer' },
	      _react2.default.createElement(
	        'small',
	        { className: 'text-muted' },
	        'by ',
	        firstName,
	        ' ',
	        lastName,
	        ' - ',
	        _react2.default.createElement(_reactIntl.FormattedRelative, { value: timestamp })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'btn-group actions' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-link edit', onClick: function onClick() {
	              return onEdit(note);
	            } },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'pencil' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-link remove', onClick: function onClick() {
	              return onRemove(note);
	            } },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'trash-o' })
	        )
	      )
	    )
	  );
	};
	
	var EditNote = function (_React$Component) {
	  (0, _inherits3.default)(EditNote, _React$Component);
	
	  function EditNote() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EditNote);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = EditNote.__proto__ || (0, _getPrototypeOf2.default)(EditNote)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      content: _this.props.note.content || ''
	    }, _this.contentChanged = function (event) {
	      _this.setState({
	        content: event.target.value
	      });
	    }, _this.save = function () {
	      _this.props.onSave(_this.state.note, content);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EditNote, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          note = _props.note,
	          onCancel = _props.onCancel,
	          onSave = _props.onSave;
	      var content = this.state.content;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card note editing' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-title' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.newNoteTitle)
	          ),
	          _react2.default.createElement('textarea', { rows: '7', className: 'form-control', value: content, onChange: this.contentChanged })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-right' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-secondary mr-3', onClick: function onClick() {
	                  return onCancel(note);
	                } },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary', onClick: function onClick() {
	                  return onSave(note, content);
	                } },
	              'Save'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return EditNote;
	}(_react2.default.Component);
	
	exports.ViewNote = ViewNote;
	exports.EditNote = EditNote;

/***/ },

/***/ 678:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(183);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Note = __webpack_require__(677);
	
	var _MessageDefinitions = __webpack_require__(245);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotePanel = function (_React$Component) {
	  (0, _inherits3.default)(NotePanel, _React$Component);
	
	  function NotePanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, NotePanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NotePanel.__proto__ || (0, _getPrototypeOf2.default)(NotePanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      notes: [],
	      loading: false
	    }, _this.addNote = function () {
	      _this.setState({
	        notes: [].concat((0, _toConsumableArray3.default)(_this.state.notes), [{
	          id: Math.random(),
	          content: '',
	          editing: true,
	          isNew: true
	        }])
	      });
	    }, _this.saveNote = function (note, content) {
	      _this.setState({
	        loading: true
	      });
	      if (note.isNew) {
	        window.ignite.noteService.addNote(content).then(function () {
	          _this.retrieveNotes();
	        });
	      } else {
	        window.ignite.noteService.updateNote((0, _extends3.default)({}, note, {
	          content: content
	        })).then(function () {
	          _this.retrieveNotes();
	        });
	      }
	    }, _this.cancelClicked = function (note) {
	      if (note.isNew) {
	        _this.setState({
	          notes: [].concat((0, _toConsumableArray3.default)(_this.state.notes.filter(function (n) {
	            return n.id !== note.id;
	          })))
	        });
	      } else {
	        _this.retrieveNotes();
	      }
	    }, _this.editNote = function (note) {
	      var notes = [].concat((0, _toConsumableArray3.default)(_this.state.notes));
	      notes.forEach(function (n) {
	        if (note.id === n.id) {
	          n.editing = true;
	        }
	      });
	      _this.setState({
	        notes: notes
	      });
	    }, _this.removeNote = function (note) {
	      window.ignite.noteService.removeNote(note).then(function () {
	        _this.retrieveNotes();
	      });
	    }, _this.retrieveNotes = function () {
	      _this.setState({
	        loading: true
	      });
	      window.ignite.noteService.retrieveNotes().then(function (notes) {
	        _this.setState({
	          loading: false,
	          notes: notes
	        });
	      });
	    }, _this.componentDidMount = function () {
	      _this.retrieveNotes();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(NotePanel, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          notes = _state.notes,
	          loading = _state.loading;
	
	      var renderedNotes = notes.map(function (note) {
	        return note.editing ? _react2.default.createElement(_Note.EditNote, { note: note, key: note.id, onCancel: _this2.cancelClicked, onSave: _this2.saveNote }) : _react2.default.createElement(_Note.ViewNote, { note: note, key: note.id, onEdit: _this2.editNote, onRemove: _this2.removeNote });
	      });
	      var classes = (0, _classnames2.default)({
	        loading: loading,
	        'notes-panel': true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        renderedNotes,
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          _react2.default.createElement(
	            'span',
	            { className: 'btn btn-secondary new', onClick: this.addNote },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.addNote),
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'plus' })
	          )
	        )
	      );
	    }
	  }]);
	  return NotePanel;
	}(_react2.default.Component);
	
	exports.default = NotePanel;
	module.exports = exports['default'];

/***/ }

});


/** WEBPACK FOOTER **
 ** notes.min.js
 **/